import { Deserializable } from '../../protocols/deserializable';
import { HighGuideInsightCollectionResult } from './high-guide-insight-collection-result';
import { HighGuideRecentRecommendations } from './high-guide-recent-recommendations';
import { HighGuideTrendingBrand } from './high-guide-trending-brand';

/**
 * The whole `get-highguide-insights` payload - one read backing all three home page insight widgets.
 *
 * The three branches are independent: any of them can come back empty while the others carry data, so each widget
 * decides its own empty state rather than the page deciding one for all of them.
 *
 * `windowStart` and `windowEnd` are unix seconds; `windowDays` is the span the backend actually used, which is what
 * the section copy should quote rather than a number hardcoded client side.
 */
export class HighGuideInsights implements Deserializable {
  public companyId: number;
  public windowDays: number;
  public windowStart: number;
  public windowEnd: number;
  public trendingBrands: HighGuideTrendingBrand[];
  public recentRecommendations: HighGuideRecentRecommendations;
  public insightCollections: HighGuideInsightCollectionResult[];

  onDeserialize(): void {
    const Deserialize = window?.injector?.Deserialize;
    this.trendingBrands = Deserialize?.arrayOf(HighGuideTrendingBrand, this.trendingBrands) || [];
    this.recentRecommendations = Deserialize?.instanceOf(HighGuideRecentRecommendations, this.recentRecommendations);
    this.insightCollections = Deserialize?.arrayOf(HighGuideInsightCollectionResult, this.insightCollections) || [];
  }
}
